import { Flex, Image, Text } from "@chakra-ui/react"
import { ICarDetialsTypes } from "./CarDetailsBoxTypes"
import Icon from "components/UI/atoms/Icon"
import { StyledCarNumberBox } from "./StyledCarDetailsBox"
import CarNumberBox from "../CarNumberBox"
import { formatCarGovNumber } from "components/shared/modals/ClientAutosModal/utils"


const CarDetialsBox: React.FC<ICarDetialsTypes> = ({
  vehicle
}) => {

  const title = `${vehicle?.model} ${vehicle?.bodyType}`
  const carNumber = formatCarGovNumber(vehicle?.govNumber)  //format 
  return (
    <Flex width="300px" borderRadius={"m"} gap="15px" boxShadow="tertiary" padding={"16px 23px 21px 18px"}>
      <Flex bgColor={"#E9F2FD"} padding="2" borderRadius={"40px"} display={"flex"} alignItems="center" justifyContent={"center"} >
        <Image src={vehicle?.bodyTypeImgUrl || ""} w="46px" height="46px" />
        {/* <Icon
                      name="car"
                      iconStyles={{
                        width: "60px",
                        height: "18px",
                        fill: "darkGrey",
                      }}
                    /> */}
      </Flex>
      <Flex gap={"5px"} flexDirection={"column"}>
        <Text fontSize={"m"} color="#7D90A8" fontStyle={"bold"} >{title}</Text>
        <StyledCarNumberBox>
          <CarNumberBox height="35px" width="150px" title={vehicle?.govNumber} />
        </StyledCarNumberBox>
      </Flex>
    </Flex>
  )
}

export default CarDetialsBox
